export const isUsingPersistentQueryCache = JSON.parse(
  import.meta.env.VITE_USE_PERSISTED_QUERIES ?? 'false'
)

export const replaySessionSampleRate = Number(
  JSON.parse(import.meta.env.VITE_REPLAY_SESSION_SAMPLE_RATE ?? '0.1')
)

export const replayOnErrorSampleRate = Number(
  JSON.parse(import.meta.env.VITE_REPLAY_ON_ERROR_SAMPLE_RATE ?? '1')
)

export const isUsingStickySessions = JSON.parse(
  import.meta.env.VITE_USE_STICKY_SESSIONS ?? 'false'
)
